/* eslint-disable react-native/no-unused-styles */
/* eslint-disable react-native/no-color-literals */
/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/prop-types */
import React, { useEffect, useRef, useState } from 'react';
import {
  Text,
  View,
  StyleSheet,
  Image,
  Pressable,
  ScrollView,
} from 'react-native';
import { Modalize } from 'react-native-modalize';
import Toast from 'react-native-toast-message';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { getFormatedDate } from 'react-native-modern-datepicker-dayjs';

import Colors from '~global/Colors';
import WithLocalSvg from '@web-components/common/WithLocalSvg';
import { useDispatch, useSelector } from 'react-redux';
import { imageCdn } from '~global/helpers';
const Button = React.lazy(() => import('@web-components/form/Button'));
import PreOrderDeliveryDate from '@web-components/product/PreOrderDeliveryDate';
import PreOrderLabel from '@web-components/product/PreOrderLabel';
import ExclusiveDealsLabel from '@web-components/product/ExclusiveDealsLabel';
import * as cartActions from '~store/cart/actions/cart';
import { currencyFormat, formatPrice } from '~global/helpers';
import { isWeb, isNative } from '~global/screens';
import { GoogleTagManager, InternalTracking } from '~global/sociolla.dm.lib';
import { addToBagBabyRegistry } from '~store/baby-registry/thunks';
import RegistryUtils from '~global/utils/registry';
import ProductUtils from '~global/utils/product';

const defaultImage = require('~assets/img/dummy_product.png');

// eslint-disable-next-line react/display-name
const ModalAddToCart = () => {
  const { $get, $size } = global;
  const dispatch = useDispatch();
  const insets = useSafeAreaInsets();
  const modalizeRef = useRef(null);
  const isModalShow = useSelector((state) => state.modal.addToCart.isShow);
  const data = useSelector((state) => state.modal.addToCart.data);
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
  const isRegistryChooseCombinations = data?.isRegistryChooseCombinations;
  const productData = data && data.productData ? data.productData : '';
  const babyRegistry = data && data.babyRegistry ? data.babyRegistry : null;
  const UtilsRegistry = new RegistryUtils(babyRegistry);
  const UtilsProduct = new ProductUtils(productData || {});
  const [selectedCombination, setSelectedCombination] = useState({});
  const [selectedPrice, setSelectedPrice] = useState('');
  const [selectedPriceAfterDiscount, setSelectedPriceAfterDiscount] =
    useState('');
  const [selectedDiscount, setSelectedDiscount] = useState('');
  const [selectedImage, setSelectedImage] = useState('');
  const [addToCartLoading, setAddToCartLoading] = useState(false);
  const [choosenPackState, setChoosenPackState] = useState(0);
  const [choosePack, setChoosePack] = useState([]);
  const user = useSelector((state) => state.auth.user);
  const isBabyRegistry = babyRegistry || isRegistryChooseCombinations;
  const buttonTitle = isBabyRegistry ? 'Add to Registry' : 'Add to Bag';
  const preOrderDeliveryDate =
    Object.keys(selectedCombination).length > 0 &&
    selectedCombination?.delivery_date
      ? getFormatedDate(
          new Date(selectedCombination?.delivery_date),
          'DD MMM YYYY',
        )
      : null;
  const openHandler = () => {
    modalizeRef.current?.open();
  };

  const closeHandler = () => {
    modalizeRef.current?.close();
  };

  useEffect(() => {
    isModalShow ? openHandler() : closeHandler();
  }, [isModalShow]);

  useEffect(() => {
    if (
      productData &&
      productData.pack_detail &&
      productData.pack_detail.length
    ) {
      let data = productData.pack_detail.filter(
        (res) => res.combinations && res.combinations.length > 1,
      );
      data = data.map((res) => {
        return {
          ...res,
          combinations: res.combinations.filter(
            (comb) => comb.is_active_in_lulla,
          ),
          selected: '',
        };
      });
      setChoosePack(data);
    } else {
      setChoosePack([]);
    }
  }, [productData]);

  useEffect(() => {
    if (typeof findCoverImageSrc != 'undefined') {
      setSelectedImage(findCoverImageSrc(choosePack[choosenPackState]), false);
    }
  }, [choosenPackState]);

  const setModalHide = () => {
    dispatch({ type: 'MODAL/HIDE', modalName: 'addToCart', data });
    resetData();
  };

  const resetData = (force) => {
    setTimeout(() => {
      if (force) {
        dispatch({ type: 'MODAL/HIDE', modalName: 'addToCart', data });
      }
      if (choosePack.length) {
        setChoosePack(
          choosePack.map((res) => {
            return {
              ...res,
              selected: '',
            };
          }),
        );
      }
      setSelectedCombination({});
      setSelectedImage('');
      setSelectedPrice('');
      setSelectedPriceAfterDiscount('');
      setSelectedDiscount('');
      setChoosenPackState(0);
    }, 400);
  };

  const isInStock = (item) => {
    return item.stock && !item.is_out_of_stock_lilla ? true : false;
  };

  const setCombination = (item) => {
    if (isBabyRegistry || isInStock(item)) {
      setSelectedCombination(item);
      setSelectedImage(findCoverImageSrc(item, true));
      setSelectedPrice(item.price);
      setSelectedPriceAfterDiscount(item.price_after_discount);
      if (item.deduction_type === 'amount') {
        setSelectedDiscount(item.deduction_amount);
      }
      if (item.deduction_type === 'percentage') {
        setSelectedDiscount(item.deduction_percentage);
      }
      if (choosePack.length) {
        choosePack[choosenPackState].selected = item._id;
      }
    }
  };

  const attributesName = (attributes) => {
    const name = [];
    if (attributes) {
      for (const i in attributes) {
        // name.push({
        // 	group: i,
        // 	value: attributes[i].name
        // })
        name.push(attributes[i].name);
      }
    }
    // return name
    return name.join(' - ');
  };

  if (!productData) {
    return <></>;
  }

  const findCoverImageSrc = (item, force) => {
    let coverImageSrc =
      item && item.images
        ? item.images.filter((data) => data.is_cover)[0]
        : null;
    if (choosePack.length && choosePack[choosenPackState] && !force) {
      coverImageSrc = choosePack[choosenPackState].images
        ? choosePack[choosenPackState].images.filter((data) => data.is_cover)[0]
        : null;
    }
    coverImageSrc =
      coverImageSrc && coverImageSrc.url
        ? imageCdn({
            config: isWeb ? 'w=156' : 'w=100',
            image: coverImageSrc.url,
          })
        : null;
    return coverImageSrc;
  };

  const coverImage = selectedImage
    ? selectedImage
    : findCoverImageSrc(productData);

  const findBrandName = () => {
    if (productData && productData.brand && productData.brand.name) {
      const brandName = productData.brand.name;
      if (choosePack.length && choosePack[choosenPackState]) {
        return choosePack[choosenPackState].brand &&
          choosePack[choosenPackState].brand.name
          ? choosePack[choosenPackState].brand.name
          : '';
      }
      return brandName;
    }
  };
  const brandName = findBrandName();

  const findProductName = () => {
    if (productData && productData.name) {
      const productName = productData.name;
      if (choosePack.length && choosePack[choosenPackState]) {
        return choosePack[choosenPackState].name
          ? choosePack[choosenPackState].name
          : '';
      }
      return productName;
    }
  };
  const productName = findProductName();

  const isShadeAttribute = (combination) => {
    return combination &&
      combination.attributes &&
      'shade' in combination.attributes
      ? true
      : false;
  };

  const ShadeColor = ({ combination }) => {
    if (
      combination &&
      combination.attributes &&
      'shade' in combination.attributes
    ) {
      const value = combination.attributes.shade.value;
      if (value.indexOf('http') > -1) {
        return (
          <View style={styles.attributeColor}>
            <Image
              source={{ uri: value ? value : null }}
              style={styles.attributeColorImage}
              resizeMode="cover"
              defaultSource={defaultImage}
            />
          </View>
        );
      } else {
        return (
          <View
            style={{
              ...styles.attributeColor,
              ...styles.attributeColorImage,
              backgroundColor: value,
            }}></View>
        );
      }
    } else {
      return <></>;
    }
  };

  const addToBagHandler = () => {
    if (isRegistryChooseCombinations) {
      // dont add product to bag instead add to list registry user
      addToBabyRegistry();
      return;
    }
    setAddToCartLoading(true);
    dispatch({ type: 'MODAL/SHOW', modalName: 'loading' });
    const payload = {
      product: {
        id: productData.id,
        combination_id:
          selectedCombination && '_id' in selectedCombination
            ? selectedCombination._id
            : '',
        quantity: 1,
      },
      action: 'add',
      ...(productData.baby_registry_id
        ? {
            baby_registry_id: productData.baby_registry_id,
          }
        : {}),
    };
    const newProductData = Object.assign({}, productData);
    if (choosePack.length) {
      const listChoosen = choosePack.map((res) => {
        return {
          combination_id: res.selected,
          product_id: res.id,
          quantity: res.quantity,
        };
      });
      const pack = productData.pack_detail.map((data) => {
        const fromListChoosen = listChoosen.findIndex(
          (res) => res.product_id === data.id,
        );
        if (fromListChoosen > -1) {
          const selectedCombination = listChoosen[fromListChoosen];
          listChoosen.splice(fromListChoosen, 1);
          return selectedCombination;
        } else {
          return {
            combination_id: data.combinations[0]._id,
            product_id: data.id,
            quantity: data.quantity,
          };
        }
      });
      payload.product = {
        id: productData.id,
        combination_id: productData.default_combination._id,
        quantity: 1,
        is_pack: true,
        pack,
      };
    } else {
      newProductData.combinations = [selectedCombination];
    }

    GoogleTagManager.addToCart(
      { ...productData, default_combination: selectedCombination },
      payload.product.quantity,
    );
    InternalTracking.addToCart(
      { ...productData, default_combination: selectedCombination },
      payload.product.quantity,
    );

    if (babyRegistry) {
      const combination_id =
        selectedCombination && '_id' in selectedCombination
          ? selectedCombination._id
          : productData.default_combination._id;
      const defaultAddress = user?.address?.find(
        (address) => address.is_default,
      );
      const payload = {
        title: `${user.name} baby registry`,
        product_id: productData.id,
        combination_id,
        product_name: productData.name,
        brand: {
          id: productData.brand.id,
          name: productData.brand.name,
        },
        due_date: babyRegistry?.due_date ? babyRegistry.due_date : new Date(),
        delivery_address: babyRegistry?.delivery_address
          ? babyRegistry.delivery_address
          : defaultAddress,
        qty: UtilsRegistry.getQuantity(combination_id) + 1,
        total_purchased: 0,
      };

      dispatch(addToBagBabyRegistry(payload)).then((response) => {
        if (response.payload.success) {
          setAddToCartLoading(false);
          dispatch({ type: 'MODAL/HIDE', modalName: 'loading' });
          if (!response.error) {
            setModalHide();
            Toast.show({ text1: 'Product added to Registry' });
            dispatch({ type: 'babyRegistry/incrementTotalProducts' });
            dispatch({
              type: 'babyRegistry/updateProduct',
              product: { ...response.payload.data, ...productData },
            });
          }
        }
      });
    } else {
      // normal product, means this is not for add to baby registry

      // adding detail data for product added to cart when user wasn't logged in
      if (!isLoggedIn) {
        let detailData;

        if (payload.product.is_pack) {
          detailData = {
            ...productData,
            combination: selectedCombination,
            detail: {
              name: productData.name,
              brand: productData.brand,
              is_available: true,
              image: productData.images[0],
              price_range: productData.price_range,
              combination: {
                ...selectedCombination,
                price:
                  productData?.price_after_discount ||
                  productData?.max_price_after_discount,
                price_after_discount:
                  productData?.price_after_discount ||
                  productData?.max_price_after_discount,
              },
              ...productData.default_combination,
            },
            pack_detail: productData.pack_detail.map((item) => {
              const id = payload.product.pack.find(
                (p) => p.product_id === item.id,
              );

              const combination = item.combinations.find(
                (comb) => comb._id === id.combination_id,
              );

              return {
                ...item,
                combination_id: id.combination_id,
                combinations: combination,
              };
            }),
          };
        } else {
          detailData = productData;
        }

        payload.product.detailData = UtilsProduct.getDetailDataNotLogin({
          ...detailData,
          ...($size(selectedCombination)
            ? {
                default_combination: selectedCombination,
              }
            : {}),
        });
      }

      dispatch(cartActions.addProductToCart(payload)).then((res) => {
        setAddToCartLoading(false);
        dispatch({ type: 'MODAL/HIDE', modalName: 'loading' });
        dispatch({
          type: 'shoppingBag/setIsReloadCart',
          data: true,
        });
        if (!res.error) {
          setModalHide();
          dispatch({
            type: 'MODAL/SHOW',
            modalName: 'productAdded',
            data: {
              productData: newProductData,
              navigation: data.navigation,
            },
          });
        }
      });
    }
  };

  const addToBabyRegistry = (e) => {
    const payload = {
      product_id: productData.id,
      combination_id: $get(selectedCombination, '_id', ''),
      product_name: productData.name,
      brand: {
        id: $get(productData, 'brand.id', ''),
        name: $get(productData, 'brand.name', ''),
      },
      qty: 1,
      total_purchased: 0,
    };

    dispatch({ type: 'MODAL/SHOW', modalName: 'loading' });
    dispatch(addToBagBabyRegistry(payload)).then((response) => {
      if (response.payload.success) {
        Toast.show({ text1: 'Product added to Registry' });
        dispatch({ type: 'MODAL/HIDE', modalName: 'loading' });
        setModalHide();
      }
    });
  };

  const isAddToBagPackDisable = () => {
    if (choosePack.length) {
      return choosePack[choosenPackState].selected ? false : true;
    }
  };

  const isAddToBagDisable = () => {
    return !Object.keys(selectedCombination).length;
  };

  const ButtonChoosePack = () => {
    if (choosePack.length == 1) {
      return (
        <View style={styles.buttonContainerWeb}>
          <Button
            title={buttonTitle}
            onPress={addToBagHandler}
            titleStyle={styles.modalProductAddToBagText}
            buttonStyle={styles.modalProductAddToBagButton}
            disabledStyle={styles.modalProductAddToBagButtonDisabled}
            disabledTitleStyle={styles.modalProductAddToBagText}
          />
        </View>
      );
    } else {
      return (
        <View style={styles.modalProductButtonGroup}>
          {Boolean(choosenPackState > 0) && (
            <View style={styles.modalProductButtonLeft}>
              <Button
                title="Back"
                onPress={() => setChoosenPackState(choosenPackState - 1)}
                titleStyle={styles.modalProductAddToBagText}
                buttonStyle={[
                  styles.modalProductAddToBagButton,
                  styles.buttonContainerWeb,
                ]}
                disabledStyle={[
                  styles.modalProductAddToBagButtonDisabled,
                  styles.buttonContainerWeb,
                ]}
                disabledTitleStyle={styles.modalProductAddToBagText}
              />
            </View>
          )}
          <View style={styles.modalProductButtonRight}>
            <Button
              title={
                choosenPackState + 1 === choosePack.length
                  ? buttonTitle
                  : 'Next'
              }
              onPress={() =>
                choosenPackState + 1 === choosePack.length
                  ? addToBagHandler()
                  : setChoosenPackState(choosenPackState + 1)
              }
              titleStyle={styles.modalProductAddToBagText}
              buttonStyle={[
                styles.modalProductAddToBagButton,
                styles.buttonContainerWeb,
              ]}
              disabledStyle={[
                styles.modalProductAddToBagButtonDisabled,
                styles.buttonContainerWeb,
              ]}
              disabledTitleStyle={styles.modalProductAddToBagText}
              disabled={isAddToBagPackDisable()}
            />
          </View>
        </View>
      );
    }
  };

  return (
    <Modalize
      ref={modalizeRef}
      adjustToContentHeight={true}
      handleStyle={styles.handleStyle}
      modalStyle={styles.modalStyle}
      onClose={() => resetData(true)}>
      <View style={{ paddingBottom: insets.bottom }}>
        {isWeb ? (
          <View style={styles.modalHeaderWeb}>
            <Text style={styles.modalProductOptionsText}>
              Select Combination
            </Text>
            <Pressable
              style={styles.modalProductClose}
              onPress={() => setModalHide()}>
              <WithLocalSvg
                width={14}
                height={14}
                asset={require('~assets/img/product/icon-close.svg')}
              />
            </Pressable>
          </View>
        ) : (
          false
        )}
        <View style={styles.modalProductSummary}>
          <Image
            source={{ uri: coverImage ? coverImage : null }}
            style={styles.modalProductImage}
            resizeMode="cover"
            defaultSource={defaultImage}
          />
          <View style={styles.modalProductInfo}>
            {Boolean(brandName) && (
              <Text
                style={styles.modalProductBrand}
                numberOfLines={1}
                ellipsizeMode="tail">
                {brandName}
              </Text>
            )}
            {Boolean(productName) && (
              <Text
                style={styles.modalProductName}
                numberOfLines={1}
                ellipsizeMode="tail">
                {productName}
              </Text>
            )}
            {!choosePack.length && (
              <View style={styles.modalProductPriceWrapper}>
                {productData.price_after_discount_range ? (
                  <View style={styles.modalProductPriceRangeWrapper}>
                    <View style={styles.modalProductPriceAfterDiscountWrapper}>
                      <Text style={styles.modalProductPriceAfterDiscount}>
                        {selectedPriceAfterDiscount
                          ? currencyFormat(selectedPriceAfterDiscount)
                          : formatPrice(productData.price_after_discount_range)}
                      </Text>
                    </View>
                    <View>
                      <Text style={styles.modalProductPriceBeforeDiscount}>
                        {selectedPrice
                          ? currencyFormat(selectedPrice)
                          : formatPrice(productData.price_range)}
                      </Text>
                    </View>
                  </View>
                ) : (
                  <Text style={styles.modalProductPrice}>
                    {selectedPrice
                      ? currencyFormat(selectedPrice)
                      : formatPrice(productData.price_range)}
                  </Text>
                )}
              </View>
            )}
            {(productData.discount_range || selectedDiscount) &&
            Boolean(choosePack.length)
              ? true
              : false && (
                  <Text style={styles.modalProductDiscount}>
                    {selectedDiscount
                      ? '-' + currencyFormat(selectedDiscount)
                      : formatPrice(productData.discount_range)}
                  </Text>
                )}
          </View>
          {!isWeb ? (
            <Pressable
              style={styles.modalProductClose}
              onPress={() => setModalHide()}>
              <WithLocalSvg
                width={14}
                height={14}
                asset={require('~assets/img/product/icon-close.svg')}
              />
            </Pressable>
          ) : (
            false
          )}
        </View>

        <PreOrderDeliveryDate date={preOrderDeliveryDate} />

        <ScrollView style={styles.modalProductOptions}>
          {!isWeb ? (
            <Text style={styles.modalProductOptionsText}>
              Select Combination
            </Text>
          ) : (
            false
          )}
          {(!productData.pack_detail.length &&
          productData.combinations &&
          productData.combinations.length
            ? true
            : false) &&
            productData.combinations.map((combination, index) => (
              <Pressable
                style={[
                  styles.modalProductOption,
                  !isBabyRegistry && !isInStock(combination)
                    ? styles.modalProductOptionOos
                    : '',
                  babyRegistry
                    ? UtilsRegistry.hasCombinationInRegistry(combination['_id'])
                      ? styles.modalProductOptionOos
                      : ''
                    : '',
                ]}
                onPress={() => setCombination(combination)}
                key={index}>
                <View style={styles.row}>
                  <WithLocalSvg
                    asset={
                      '_id' in selectedCombination &&
                      selectedCombination._id === combination._id
                        ? require('~assets/img/common/radio-active-v2.svg')
                        : require('~assets/img/common/radio-v2.svg')
                    }
                  />
                  {isShadeAttribute(combination) && (
                    <ShadeColor combination={combination} />
                  )}
                  <View style={styles.combinationWrapper}>
                    <View>
                      <Text
                        numberOfLines={2}
                        style={styles.modalProductOptionLabel}>
                        {attributesName(combination.attributes)}
                      </Text>
                    </View>
                    <View>
                      {!UtilsProduct.isAllPreOrderProducts() &&
                        combination.delivery_date && (
                          <PreOrderLabel
                            layoutStyle={styles.layoutPreOrder}
                            textStyle={styles.preOrderText}
                          />
                        )}

                      {combination.is_exclusive_deals ? (
                        <ExclusiveDealsLabel
                          layoutStyle={[
                            styles.layoutPreOrder,
                            styles.layoutExclusiveDeals,
                          ]}
                          textStyle={[
                            styles.preOrderText,
                            styles.ExclusiveDealsText,
                          ]}
                        />
                      ) : null}
                    </View>
                  </View>
                </View>
              </Pressable>
            ))}
          {Boolean(choosePack.length) && (
            <View
              style={{
                height:
                  choosePack[choosenPackState].combinations.length > 6
                    ? 284
                    : choosePack[choosenPackState].combinations.length * 44,
              }}>
              <ScrollView showsVerticalScrollIndicator={false}>
                {choosePack[choosenPackState].combinations.map(
                  (combination, index) => (
                    <Pressable
                      style={[
                        styles.modalProductOption,
                        !isBabyRegistry && !isInStock(combination)
                          ? styles.modalProductOptionOos
                          : '',
                        babyRegistry
                          ? UtilsRegistry.hasCombinationInRegistry(
                              combination['_id'],
                            )
                            ? styles.modalProductOptionOos
                            : ''
                          : '',
                      ]}
                      onPress={() => setCombination(combination)}
                      key={index}>
                      <View style={styles.row}>
                        <WithLocalSvg
                          asset={
                            choosePack[choosenPackState].selected ===
                            combination._id
                              ? require('~assets/img/common/radio-active.svg')
                              : require('~assets/img/common/radio.svg')
                          }
                        />
                        {isShadeAttribute(combination) && (
                          <ShadeColor combination={combination} />
                        )}
                        <Text style={styles.modalProductOptionLabel}>
                          {attributesName(combination.attributes)}
                        </Text>
                      </View>
                    </Pressable>
                  ),
                )}
              </ScrollView>
            </View>
          )}
        </ScrollView>
        <View
          style={[
            styles.modalProductAddToBag,
            { bottom: insets.bottom },
            !isNative ? styles.buttonAddWeb : {},
          ]}>
          {addToCartLoading ? (
            <Button
              title={buttonTitle}
              titleStyle={styles.modalProductAddToBagText}
              buttonStyle={styles.modalProductAddToBagButton}
              disabledStyle={styles.modalProductAddToBagButtonDisabled}
              disabledTitleStyle={styles.modalProductAddToBagText}
              disabled={true}
            />
          ) : (
            <>
              {choosePack.length ? (
                <ButtonChoosePack />
              ) : (
                <Button
                  title={buttonTitle}
                  onPress={addToBagHandler}
                  titleStyle={styles.modalProductAddToBagText}
                  buttonStyle={styles.modalProductAddToBagButton}
                  disabledStyle={styles.modalProductAddToBagButtonDisabled}
                  disabledTitleStyle={styles.modalProductAddToBagText}
                  disabled={isAddToBagDisable()}
                />
              )}
            </>
          )}
        </View>
      </View>
    </Modalize>
  );
};

const styles = StyleSheet.create({
  row: { flexDirection: 'row' },
  modalHeaderWeb: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingTop: 20,
    paddingBottom: 5,
    paddingHorizontal: 15,
  },
  modalProductSummary: {
    backgroundColor: '#F9F9F9',
    paddingHorizontal: 16,
    paddingTop: 30,
    paddingBottom: 24,
    flexDirection: 'row',
    marginBottom: 10,
    ...(isWeb
      ? {
          width: 'calc(100% - 30px)',
          marginHorizontal: 'auto',
          borderRadius: 5,
          paddingTop: 15,
          paddingBottom: 15,
          paddingHorizontal: 15,
        }
      : {}),
  },
  modalProductImage: {
    width: 64,
    height: 64,
    marginRight: 12,
    borderRadius: 8,
    overflow: 'hidden',
  },
  modalProductInfo: {
    paddingTop: 4,
    paddingRight: 16,
    flex: 1,
  },
  modalProductBrand: {
    fontSize: 11,
    lineHeight: 14,
    fontFamily: 'satoshi-black',
    letterSpacing: 1,
    color: '#A775C8',
    marginBottom: 3,
    textTransform: 'uppercase',
  },
  modalProductName: {
    fontSize: 13,
    lineHeight: 16,
    fontFamily: 'satoshi-medium',
    color: '#25182E',
    marginBottom: 6,
  },
  modalProductPriceWrapper: {
    marginBottom: 2,
  },
  modalProductPriceRangeWrapper: {
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  modalProductPrice: {
    fontSize: 13,
    lineHeight: 16,
    fontFamily: 'satoshi-black',
    color: '#25182E',
  },
  modalProductPriceAfterDiscount: {
    fontSize: isWeb ? 14 : 12,
    lineHeight: isWeb ? 14 : 12,
    fontFamily: 'satoshi-black',
    color: '#F05B68',
  },
  modalProductPriceAfterDiscountWrapper: {
    marginRight: 6,
  },
  modalProductPriceBeforeDiscount: {
    fontSize: isWeb ? 12 : 10,
    lineHeight: isWeb ? 14 : 12,
    fontFamily: 'satoshi-medium',
    textDecorationLine: 'line-through',
    color: Colors.grey1,
  },
  modalProductDiscount: {
    fontSize: 13,
    lineHeight: 18,
    fontFamily: 'satoshi-medium',
    color: Colors.red0,
  },
  modalProductClose: {
    position: 'absolute',
    top: isWeb ? 19 : 12,
    right: 12,
    width: 22,
    height: 22,
    alignItems: 'center',
    justifyContent: 'center',
  },
  handleStyle: {
    top: 26,
    backgroundColor: isWeb ? 'transparent' : Colors.grey0,
    height: 3,
    width: 38,
  },
  modalStyle: {
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
    overflow: 'hidden',
    ...(isWeb
      ? {
          width: 390,
          margin: 'auto',
          borderRadius: 8,
        }
      : {}),
  },
  modalProductOptions: {
    paddingTop: 24,
    paddingHorizontal: 16,
    paddingBottom: 68,
    ...(isWeb ? { paddingTop: 15, maxHeight: 320 } : {}),
  },
  modalProductOption: {
    ...(isWeb && {
      cursor: 'pointer',
    }),
    paddingVertical: 10,
  },
  modalProductOptionOos: {
    opacity: 0.2,
    pointerEvents: 'none',
  },
  modalProductOptionsText: {
    fontSize: 16,
    lineHeight: 20,
    fontFamily: 'satoshi-black',
    marginBottom: 16,
    color: '#25182E',
  },
  modalProductOptionLabel: {
    fontSize: 14,
    lineHeight: 19,
    fontFamily: 'satoshi-medium',
    marginLeft: 16,
  },
  modalProductOptionLabelGroup: {
    textTransform: 'capitalize',
  },
  modalProductAddToBag: {
    paddingVertical: 16,
    paddingHorizontal: 16,
    backgroundColor: '#fff',
    position: 'absolute',
    left: 0,
    width: '100%',
  },
  modalProductAddToBagText: {
    fontSize: 14,
    lineHeight: 18,
    fontFamily: 'satoshi-black',
  },
  modalProductAddToBagButton: {
    backgroundColor: '#A775C8',
    borderRadius: 18,
  },
  modalProductAddToBagButtonDisabled: {
    borderRadius: 18,
  },
  buttonContainerWeb: !isNative
    ? {
        width: '100%',
      }
    : {},
  attributeColor: {
    marginLeft: 18,
  },
  attributeColorImage: {
    width: 24,
    height: 24,
    borderRadius: 12,
    overflow: 'hidden',
  },
  modalProductAddToBagLoading: {
    justifyContent: 'center',
    alignItems: 'center',
    height: 36,
  },
  modalProductButtonGroup: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    ...(!isNative ? { width: '100%' } : {}),
  },
  modalProductButtonRight: {
    width: '50%',
    paddingLeft: 6,
  },
  modalProductButtonLeft: {
    width: '50%',
    paddingRight: 6,
  },
  buttonAddWeb: {
    padding: 15,
    backgroundColor: Colors.white,
    borderTopColor: Colors.grey0,
    borderTopWidth: 1,
  },
  combinationWrapper: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    flex: 1,
  },
  deliveryDateWrapper: {
    marginTop: 16,
  },
  layoutPreOrder: {
    width: 60,
    height: 16,
    paddingLeft: 7,
    paddingTop: 3,
  },
  layoutExclusiveDeals: {
    paddingLeft: 0,
    paddingRight: 0,
    paddingTop: 0,
    width: 105,
    height: 22,
    justifyContent: 'center',
    alignItems: 'center',
  },
  preOrderText: {
    fontSize: 8,
  },
  ExclusiveDealsText: {
    fontSize: 10,
    letterSpacing: 0.5,
  },
});

export default ModalAddToCart;
